import { render, staticRenderFns } from "./QBVideoLoading.vue?vue&type=template&id=50c40ada&scoped=true&"
import script from "./QBVideoLoading.vue?vue&type=script&lang=js&"
export * from "./QBVideoLoading.vue?vue&type=script&lang=js&"
import style0 from "./QBVideoLoading.vue?vue&type=style&index=0&id=50c40ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c40ada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50c40ada')) {
      api.createRecord('50c40ada', component.options)
    } else {
      api.reload('50c40ada', component.options)
    }
    module.hot.accept("./QBVideoLoading.vue?vue&type=template&id=50c40ada&scoped=true&", function () {
      api.rerender('50c40ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/search/components/QBVideoLoading.vue"
export default component.exports